import { AnchorLink } from '@ce-cfbdigital/cgl-cfb-fe-foundation';

import CustomIcon from '../CustomIcons';
import { getAppConfig } from '../utilities';
import useIsMobile from '../utilities/useIsMobile';

import './styles/index.css';

function PermissionDenied() {
  const { path } = getAppConfig('server');
  const { lang } = getAppConfig('locale');
  const labels = getAppConfig('permissionDeniedLabels');
  const { title, subTitle, buttonBack } = labels[lang];

  const { isMobile } = useIsMobile();
  return (
    <div className="permission-denied__container">
      <div className="permission-denied__icon">
        <CustomIcon type="noEncyption" size={isMobile ? 18 : 24} />
      </div>
      <div className="permission-denied__title">
        <h1 className="permission-denied__title-heading b">{title}</h1>
        <p className="permission-denied__title-paragraph">{subTitle}</p>
      </div>
      <div className="permission-denied__button">
        <AnchorLink
          href={`${path}/dashboard`}
          className="permission-denied__button-back eta b"
          innerHTML={buttonBack}
        />
      </div>
    </div>
  );
}

PermissionDenied.propTypes = {};

export default PermissionDenied;
